import "./footer.css";

import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import AOS from "aos";
import "aos/dist/aos.css";

import instagram from "../../assets/icons/instagram.png";
import linkedin from "../../assets/icons/linkedin.png";
import whatsapp from "../../assets/icons/whatsapp.png";
import WhatsappFixed from "../../assets/icons/whatssapp.svg";

export default function Footer() {
  useEffect(() => {
    AOS.init();
  }, []);

  const navigate = useNavigate();

  function goToIntagram() {
    window.open(`https://www.instagram.com/leandro.asalles/`);
  }

  function goToLinkedin() {
    window.open(`https://www.linkedin.com/in/leandro-salles-4b492b6a/`);
  }

  function sendMessage() {
    let phone = 5531996101036;
    let text = "Olá, vi sua página de Dev. Vamos conversar?";
    window.open(`https://api.whatsapp.com/send?phone=${phone}&text=${text}`);
  }

  function goToContact() {
    navigate("/contact");
  }

  return (
    <div className="footer" id="footer">
      <div className="footer--first" data-aos="fade-down">
        <p className="footer--tittle">Vamos trabalhar juntos?</p>
        <p className="footer--text">
          Se você gostou do meu trabalho e quer que eu tire sua ideia do papel ou faça parte do seu
          time, entre em contato comigo!
        </p>
        <button className="footer--first-btn" onClick={goToContact}>Entre em contato</button>
      </div>

      <div className="footer--second">
        <div className="footer--second-container">
          <div className="footer--info">
            <p className="footer-logo">Leandro Salles</p>
            <p className="footer-desription">Desenvolvedor Front-end</p>
          </div>
          <div className="footer--icons">
            <img
              className="footer--icon"
              src={instagram}
              alt="Logo do instagram"
              onClick={goToIntagram}
            />
            <img
              className="footer--icon"
              src={linkedin}
              alt="Logo do linkedin"
              onClick={goToLinkedin}
            />
            <img
              className="footer--icon"
              src={whatsapp}
              alt="Logo do whatsapp"
              onClick={sendMessage}
            />
          </div>
        </div>
        <p className="copyright">Made by LeandroSalles - 2023</p>
      </div>

      
      <div className="whatsapp" onClick={sendMessage}>
        <img src={WhatsappFixed} alt="" />
        <span className="tooltip">Vamos conversar?</span>
      </div>
    </div>
  );
}
